export const detailedEventList = [
	{
        id: 'wedding-decor',
		header: 'weddings, receptions & other social functions',
		icon: 'CelebrationOutlinedIcon',
        image: 'image2',
		content:
			'We offer a wide range of Decor in a multitude of colours and designs to suit the needs of virtually all the social occasions and gatherings, keeping in view the latest trends and designs. We have a courteous and an experienced staff.',
        features: [
            'Traditional & Modern Mandap Designs',
            'Theme-based Entrance Decor',
            'Stage & Varmala Setup',
            'Custom Seating Arrangements',
            'Royal Tenting & Canopy'
        ]
	},
	{
        id: 'lighting',
		header: 'lighting arrangements',
		icon: 'WbIncandescentOutlinedIcon',
        image: 'image3',
		content:
			'We provide specialized lighting arrangements including general lighting, smart lighting, and decorative lighting to serve the purpose for all occasions and moods. Our credible and trained electrical staff ensures safety and brilliance.',
        features: [
            'Ambient Mood Lighting',
            'Grand Chandelier Installations',
            'Spotlights & Focus Lights',
            'LED Wash & Pixel Lighting',
            'Safe Electrical Management'
        ]
	},
	{
        id: 'floral',
		header: 'floral decorations',
		icon: 'LocalFloristOutlinedIcon',
        image: 'image4',
		content:
			'We provide interactive, colorful and tasteful floral decorations which enhances the joyous mood of a celebration with a charming fragrance that is superior in comparison to artificial air fresheners.',
        features: [
            'Fresh Exotic Flower Imports',
            'Artificial Silk Floral Work',
            'Floral Wall & Arch Backdrops',
            'Centerpiece Designs',
            'Car & Suite Decoration'
        ]
	},
	{
        id: 'corporate',
		header: 'corporate events',
		icon: 'BusinessIcon',
        image: 'image17',
		content:
			'Keeping in mind the various categories of events we also have a strong foothold in the sector Corporate events. We have arranged for a variety of corporate gatherings to name a Dandiya nights, Annual General Meetings, Award Functions.',
        features: [
            'Professional Stage & Podium',
            'Sound & PA Systems',
            'Exhibition Stall Design',
            'Formal Seating Layouts',
            'Branding & Signage'
        ]
	},
	{
        id: 'entertainment',
		header: 'live concerts & entertainment nights',
		icon: 'StreamOutlinedIcon',
        image: 'image0',
		content:
			'We provide a vast range of entertainment options to our clients, which include Music Systems, DJ, Dance Floor, Live bands, Dhols and Tasha to make your night energetic.',
        features: [
            'Professional Line Array Sound',
            'Concert Stage & Trussing',
            'Smoke & Cold Fire Pyros',
            'LED Screen Backdrops',
            'Artist Management'
        ]
	},
	{
        id: 'birthday',
		header: 'birthday parties',
		icon: 'CakeIcon',
        image: 'image8',
		content:
			'Birthday is one day which makes every person feel very special. We are further obliged to cater our special clients with the best of our decor designs and colors to make that day even more eventful.',
        features: [
            'Kids Theme Decorations',
            'Balloon Art & Arches',
            'Custom Photo Booths',
            'Fun Activity Stalls',
            'Cake Table Specials'
        ]
	},
];

export const eventList = [
	{
		header: 'Decoration & Tenting',
		content: '',
		icon: 'CelebrationOutlinedIcon',
	},
	{
		header: 'Floral Decorations',
		content: '',
		icon: 'LocalFloristOutlinedIcon',
	},
	{
		header: 'Lighting Arrangements',
		content: '',
		icon: 'WbIncandescentOutlinedIcon',
	},
	{
		header: 'Live Concerts',
		content: '',
		icon: 'StreamOutlinedIcon',
	},
	{
		header: 'Entertainment Nights',
		content: '',
		icon: 'SportsHandballOutlinedIcon',
	},
	{
		header: 'Photographers',
		content: '',
		icon: 'PhotoCameraOutlinedIcon',
	},
	{
		header: 'Sounds & DJ',
		content: '',
		icon: 'SpeakerOutlinedIcon',
	},
	{
		header: 'Band, Dhol',
		content: '',
		icon: 'MusicNoteOutlinedIcon',
	},
	{
		header: 'Celebrities',
		content: '',
		icon: 'Face2Icon',
	},
	{
		header: 'Theme parties',
		content: '',
		icon: 'ColorLensIcon',
	},
	{
		header: 'Singers',
		content: '',
		icon: 'KeyboardVoiceOutlinedIcon',
	},
	{
		header: 'Anchors',
		content: '',
		icon: 'Man3OutlinedIcon',
	},
	{
		header: 'Transportation & Logistics',
		content: '',
		icon: 'CommuteOutlinedIcon',
	},
	{
		header: 'Wedding Dress Designers',
		content: '',
		icon: 'CheckroomIcon',
	},
	{
		header: 'Makeup Artists',
		content: '',
		icon: 'Diversity1Icon',
	},
	{
		header: 'Corporate Events',
		content: '',
		icon: 'BusinessIcon',
	},
	{
		header: 'Birthday Parties',
		content: '',
		icon: 'CakeIcon',
	},
];

export const detailsList = [
	{
		header: 'decor experts ',
		image: 'decor',
		content:
			'Our team consists of experts of the industry, who are trustworthy and flexible to your needs. We keep ourselves updated with latest trends and designs and always ask our esteemed clients to give us that free hand to improvise the designs as per the demand of the theme or circumstance. "Quality is a right not a privilege"',
	},
	{
		header: 'we are professional',
		image: 'professional',
		content:
			'Professionals are good at their jobs. They have mastered their job skills. That mastery builds confidence with clients as well as colleagues, managers, and suppliers. Honor commitments. Being responsible certainly means being a person others can count on- getting the job done right, and on time delivery. We make your dreams come true in real sense.',
	},
	{
		header: 'reasonable price',
		image: 'price',
		content:
			'A fair and reasonable price is the price point for a good or service that is fair to both parties involved in the transaction. This amount is based upon the agreed conditions, promised quality and timeliness of contract performance. Deliver the things committed in time is our USP Value for money is our assurance.',
	},
	{
		header: 'free consultation ',
		image: 'consultation',
		content:
			'We provide a free consultation it means that we sit down with you, hear about your ideas and requirements, and give you some initial thoughts incorporated with the latest ideas and designs in trend about it, at no charge or obligation to you.',
	},
	{
		header: '24/7 support',
		image: 'support',
		content:
			'24x7 means "24 hours a day, 7 days a week" is used to describe our services. Our team is available at your service to look after the minute details of the ongoing event. The motto is to give you hassle free experience to the atmost satisfaction.',
	},
	{
		header: 'delightful experience',
		image: 'delightful',
		content:
			'The growing number of satisfied clients and successful completion of events is a testimony to the consistent quality of services provided by us. We make sure to walk an extra mile along with what was commitment to make it a wonderful experience for you ensuring that we are by your side for the forth coming events in your life.',
	},
];

export const welcomeSection = {
	header: 'Welcome to Shri Hari Tent House!',
	content:
		'Shri Hari Tent House is a wedding designing and event planning company, set up in 2022 with an extensive in-house production facility, from idea to reality, from fabric to upholstery and from flowers to lighting.',
};

export const counterList = [
	{
		firstImage: 'image22',
		secondImage: 'image23',
		count: new Date().getFullYear() - 2021,
		content: 'Year Of Experience',
		suffix: '+',
	},

	{
		firstImage: 'image24',
		secondImage: 'image25',
		count: 116,
		content: 'Completed Event',
		suffix: '+',
	},

	{
		firstImage: 'image26',
		secondImage: 'image27',
		count: 100,
		content: 'Service Quality',
		suffix: '%',
	},

	{
		firstImage: 'image28',
		secondImage: 'image21',
		count: 100,
		content: 'Setisfied Client',
		suffix: '%',
	},
];

export const teamList = [
    {
        name: 'Deependra Singh Thakur',
        role: 'Founder & Head of Operations',
        bio: 'With over 20 years of experience in the event industry, Deependra leads the strategic direction and on-ground execution of all major projects.',
        phone: '+91 9827078928'
    },
    {
        name: 'Dharmendra Singh Thakur',
        role: 'Co-Founder & Lead Designer',
        bio: 'Dharmendra is the creative force behind our most stunning decors, ensuring every floral and lighting detail is perfect for our clients.',
        phone: '+91 9300661900'
    },
    {
        name: 'Kundan Singh Thakur',
        role: 'Technical Leader',
        bio: 'Kundan leads the digital transformation of Shri Hari, ensuring our technology platforms provide a seamless experience for our clients.',
        phone: '+91 8817478600'
    }
];

export const processSteps = [
    {
        title: 'Initial Consultation',
        description: 'We sit down with you to understand your vision, budget, and requirements for the big day.',
        icon: 'Search'
    },
    {
        title: 'Conceptual Design',
        description: 'Our creative team develops a unique theme and 3D layout to bring your ideas to life.',
        icon: 'Brush'
    },
    {
        title: 'Planning & Coordination',
        description: 'We handle all logistics, from tenting and lighting to floral imports and seating arrangements.',
        icon: 'Event'
    },
    {
        title: 'Flawless Execution',
        description: 'Our professional team manages the event on-ground, ensuring every detail is exactly as planned.',
        icon: 'CheckCircle'
    }
];

export const faqList = [
    {
        question: 'How far in advance should I book?',
        answer: 'We recommend booking at least 3-6 months in advance for large weddings, but we also handle short-notice events based on availability.'
    },
    {
        question: 'Do you offer customized packages?',
        answer: 'Absolutely! Every event is unique, and we tailor our services to fit your specific needs, themes, and budget.'
    },
    {
        question: 'What areas do you serve?',
        answer: 'We primarily serve Ashta, Sehore, and nearby regions, but we are open to handling destination events across the state.'
    },
    {
        question: 'Do you provide full-service planning?',
        answer: 'Yes, from tenting and decor to sound, photography, and makeup artists, we provide a complete end-to-end event management solution.'
    }
];

export const testimonialList = [
    {
        name: 'Rajendra Singh Thakur',
        quote: 'The wedding decor was beyond my expectations. Shri Hari Team managed everything so professionally!',
        sign: 'Constructor',
        from: 'Arniya Ram',
        rating: 5
    },
    {
        name: 'Vijendra Singh Sendhav',
        quote: 'Prompt service and amazing quality of lighting and tenting. Highly recommended for any grand event.',
        sign: 'Sendhav Dairy Ashta',
        from: 'Ashta',
        rating: 5
    },
    {
        name: 'Arjun Singh',
        quote: 'Their attention to detail in floral decorations is incredible. They made our family function truly special.',
        sign: 'Secretary',
        from: 'Bager',
        rating: 4
    }
];

export const imageListData = [
	{
		img: 'https://i.pinimg.com/736x/d1/4b/ef/d14bef5a774c83f955f4f8c9dd8e5445.jpg',
		title: 'Breakfast',
		rows: 2,
		cols: 2,
	},
	{
		img: 'https://5.imimg.com/data5/EI/SD/HZ/SELLER-81639429/tent-house-500x500.jpg',
		title: 'Burger',
	},
	{
		img: 'https://cdn0.weddingwire.in/vendor/7893/3_2/960/jpg/tent-house-bajrang-tent-house-wedding-decor-25_15_307893-159057176771515.jpeg',
		title: 'Camera',
	},
	{
		img: 'https://4.imimg.com/data4/GG/IK/MY-6472606/wedding-tent-500x500.jpg',
		title: 'Coffee',
		cols: 2,
	},
	{
		img: 'https://i.pinimg.com/564x/2f/9c/d3/2f9cd396e39d3ec1674b4206f49506b4.jpg',
		title: 'Hats',
		cols: 2,
	},
	{
		img: 'https://cdn0.weddingwire.in/vendor/4537/3_2/960/jpg/tent-house-shagoon-tent-house-wedding-decor-7_15_404537-164791966338826.jpeg',
		title: 'Honey',
		author: '@arwinneil',
		rows: 2,
		cols: 2,
	},
	{
		img: 'https://cdn0.weddingwire.in/vendor/4288/3_2/960/jpg/mandap_15_44288.jpeg',
		title: 'Basketball',
	},
	{
		img: 'https://i.pinimg.com/originals/9c/8a/08/9c8a08a4a88b2cc53acafc6dda64aa51.jpg',
		title: 'Fern',
	},
	{
		img: 'https://3.imimg.com/data3/VC/NS/MY-8902469/wedding-pandal-500x500.jpg',
		title: 'Mushrooms',
		rows: 2,
		cols: 2,
	},
	{
		img: 'https://media.weddingz.in/images/7d1e4df68922ac59df4c9c4631a8ccce/10-beautiful-wedding-tent-ideas-draped-fabric.jpg',
		title: 'Tomato basil',
	},
	{
		img: 'https://cdn0.weddingwire.in/vendor/7472/3_2/960/jpg/celebration_15_37472.jpeg',
		title: 'Sea star',
	},
	{
		img: 'https://5.imimg.com/data5/SELLER/Default/2021/9/XM/IE/NX/18479201/tent-500x500.jpg',
		title: 'Bike',
		cols: 2,
	},
	{
		img: 'https://5.imimg.com/data5/NF/FY/DZ/SELLER-86221891/wedding-ceiling-500x500.jpg',
		title: 'Breakfast',
		rows: 2,
		cols: 2,
	},
	{
		img: 'https://5.imimg.com/data5/NX/CL/MY-48898256/wedding-flower-ceiling-500x500.jpg',
		title: 'Burger',
	},
	{
		img: 'https://static.connect2india.com/c2icd/company_resources/5790868/images/products/product-decorative-wedding-ceiling-tent.jpg',
		title: 'Camera',
	},
	{
		img: 'https://4.imimg.com/data4/CW/IC/MY-5828518/wedding-tent-decoration-services-500x500.jpg',
		title: 'Coffee',
		cols: 2,
	},
	{
		img: 'https://content3.jdmagicbox.com/comp/balrampur/w1/9999p5263.5263.191119224823.d1w1/catalogue/niyaz-tent-house-wedding-decorations-balrampur-tent-house-b0n1rj5k7m.jpg',
		title: 'Hats',
		cols: 2,
	},
	{
		img: 'https://cdn0.weddingwire.in/vendor/4342/3_2/960/jpg/43415500-1323206254486201-246579140524769280-n_15_44342.jpeg',
		title: 'Honey',
		author: '@arwinneil',
		rows: 2,
		cols: 2,
	},
	{
		img: 'https://cdn0.weddingwire.in/vendor/1517/3_2/960/png/kkkkkkkkkkkkkkk_15_171517-1553608020.jpeg',
		title: 'Basketball',
	},
	{
		img: 'https://miro.medium.com/max/564/1*iMdQijuIntnauTu8qUNg_w.jpeg',
		title: 'Fern',
	},
	{
		img: 'https://cdn0.weddingwire.in/vendor/6441/3_2/960/jpg/tent-house-rupesh-tent-house-wedding-tenting1_15_306441-158919434914206.jpeg',
		title: 'Mushrooms',
		rows: 2,
		cols: 2,
	},
	{
		img: 'https://i.pinimg.com/474x/15/ce/1e/15ce1ef2fbf8901128ae7f75fa11ebee.jpg',
		title: 'Tomato basil',
	},
	{
		img: 'https://i.pinimg.com/564x/2f/9c/d3/2f9cd396e39d3ec1674b4206f49506b4.jpg',
		title: 'Sea star',
	},
	{
		img: 'https://image.wedmegood.com/resized/450X/uploads/member/1301439/1592241029_Screenshot_from_2020_06_15_22_32_23.png',
		title: 'Bike',
		cols: 2,
	},
];

export const clientList = [
	{
		name: 'Rajendra Singh Thakur',
		sign: 'Constructor',
		from: 'Arniya Ram',
	},
	{
		name: 'Dham Sarkar',
		sign: '',
		from: 'Bapchya Dham',
	},
	{
		name: 'Vijendra Singh Sendhav',
		sign: 'Sendhav Dairy Ashta',
		from: 'Ashta',
	},
	{
		name: 'Kripal Singh Patel',
		sign: '',
		from: 'Bapchya Baramat',
	},
	{
		name: 'Rajendra Singh Patel',
		sign: '',
		from: 'Baliyakhedi',
	},
	{
		name: 'Arjun Singh',
		sign: 'Secretary',
		from: 'Bager',
	},
	{
		name: 'Dinesh Ji Patidar',
		sign: '',
		from: 'Khajuriya Kasam',
	},
	{
		name: 'Dhiraj Singh',
		sign: 'Sarkar Group Ashta',
		from: 'Paroliya',
	},
	{
		name: 'Jitendra Singh Thakur',
		sign: '',
		from: 'Hajipur',
	},
	{
		name: 'Kuldeep Singh Thakur',
		sign: '',
		from: 'Mugli',
	},
	{
		name: 'Rajendra Singh',
		sign: 'Government Teacher',
		from: 'Mardakhedi',
	},
	{
		name: 'Yogendra Singh',
		sign: 'Secretary Sab',
		from: 'Arniya Gaji',
	},
	{
		name: 'Veerendra Thakur',
		sign: 'Patwari',
		from: 'Mahatwada',
	},
];
